export default "__VITE_ASSET__BVQnh40H__"